module.exports = __webpack_public_path__ + "images/imageUploadError_hotSpot.svg";